import type { ComponentType } from 'react';

import { ChatBubbleIcon, GroupsIcon, InsightsIcon, SpeakerIcon, StarIcon, TrendingIcon } from '@change/ds-icons';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';

export type ServiceType = Readonly<{
	Icon: ComponentType<{ size?: number }>;
	title: TranslationKey;
	body: TranslationKey;
}>;

export const SERVICES: ReadonlyArray<ServiceType & Readonly<{ id: string }>> = [
	{
		id: 'starters',
		Icon: GroupsIcon,
		title: translationKey('corgi.press_page.services.items.starters.title'),
		body: translationKey('corgi.press_page.services.items.starters.body'),
	},
	{
		id: 'trends',
		Icon: TrendingIcon,
		title: translationKey('corgi.press_page.services.items.trends.title'),
		body: translationKey('corgi.press_page.services.items.trends.body'),
	},
	{
		id: 'data',
		Icon: InsightsIcon,
		title: translationKey('corgi.press_page.services.items.data.title'),
		body: translationKey('corgi.press_page.services.items.data.body'),
	},
	{
		id: 'experts',
		Icon: ChatBubbleIcon,
		title: translationKey('corgi.press_page.services.items.experts.title'),
		body: translationKey('corgi.press_page.services.items.experts.body'),
	},
	{
		id: 'brands',
		Icon: StarIcon,
		title: translationKey('corgi.press_page.services.items.brands.title'),
		body: translationKey('corgi.press_page.services.items.brands.body'),
	},
	{
		id: 'speakers',
		Icon: SpeakerIcon,
		title: translationKey('corgi.press_page.services.items.speakers.title'),
		body: translationKey('corgi.press_page.services.items.speakers.body'),
	},
];
